import { buildCanonicalIndices } from '../services/indicesCanonical'
import indicesFixture from '../fixtures/indices-reales.json'

/**
 * Build a synthetic array of remuneration rows for testing/benchmarking.
 * Amounts start at 80000 and increment by 850 per row.
 */
export function buildRows(count = 240, startYear = 2006, startMonth = 1, tipoActividad) {
  const rows = []
  let y = startYear
  let m = startMonth
  for (let i = 0; i < count; i += 1) {
    const key = `${y}-${String(m).padStart(2, '0')}`
    const base = 80000 + i * 850
    const row = {
      periodoKey: key,
      periodoISO: key,
      periodo: `${String(m).padStart(2, '0')}/${y}`,
      montoOriginal: base,
      montoSujetoAAporte: base,
      monto: base,
      remImpSS: base,
      incluirEnPromedio: true,
      invalidoPorCese: false,
      estadoIdentidad: 'FACTUAL',
      confianzaIdentidad: 100,
    }
    if (tipoActividad) {
      row.tipoActividad = tipoActividad
    }
    rows.push(row)
    m += 1
    if (m > 12) { m = 1; y += 1 }
  }
  return rows
}

/**
 * Build canonical indices covering 1994-01 to 2026-06 using the dense monthly
 * fixture (390 points per series) instead of the old 4-point sparse interpolation.
 * Source: scripts/generate-indices-fixture.cjs
 */
export function buildIndices() {
  return buildCanonicalIndices(indicesFixture)
}
